import { useDecision } from "@optimizely/react-sdk";
import { Navigate } from "react-router-dom";
import { ComponentType } from "react";

export interface WithFeatureFlagOptions {
  featureFlag: string;
  redirectTo?: string;
}

export const withFeatureFlag = <P extends object>(
  Component: ComponentType<P>,
  options: WithFeatureFlagOptions
): ComponentType<P> => {
  const WrappedComponent: React.FC<P> = (props) => {
    const { featureFlag, redirectTo = "/dashboard" } = options;
   
    if (!featureFlag) {
      return <Component {...(props as P)} />;
    }

    const [decision, clientReady] = useDecision(featureFlag, {
      autoUpdate: true,
    });
  
    if (!clientReady) {
      return null;
    }

    if (!decision.enabled) {
      return <Navigate to={redirectTo} replace />;
    }

    return <Component {...(props as P)} />;
  };

  return WrappedComponent as ComponentType<P>;
};

export default withFeatureFlag;
